/**
 * @module containers/app
 * @description Barrel export for App container
 */

export { App } from './app';
export { default } from './app';
